<template>
  <div class="page-wrapper">
    <TrfGlobalLoader v-if="isFormLoading" v-e2e="'template-loader'" type="fixed" />
    <div v-if="!isFormLoading" class="container">
        <h1 v-html="pageTitle" class="has-text-dark" style="font-size:36px"></h1>
        <hr/>
        <div class="is-flex is-justify-content-center">
          <div tabindex="-1" @focusin="stopFocus">
            <div v-if="displayDefault" class="default-forms box-visualizar">
              <div class="form-wrapper mb-5">
                <TrfEmpresaFormularioBase :preview="true" :acoesAnexo="[]"></TrfEmpresaFormularioBase>
              </div>
              <div class="form-wrapper">
                <TrfSocioFormularioBase :preview="true"></TrfSocioFormularioBase>
              </div>
            </div>
            <div v-else class="personalized-forms">
              <TrfVisualizarForm :pFormData="formData"></TrfVisualizarForm>
            </div>
          </div>
        </div>
        <hr />
        <div class="is-flex is-justify-content-flex-end pb-5 action-box">
          <button id="visualizar-form-btn-voltar" class="button is-primary" tabindex="0" v-e2e="'visualizar-formulario-btn-voltar'" @click="doVoltar">
              <span>Voltar</span>
          </button>
        </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { routerUtils } from '../../../util/router.utils';
import Formulario from '../../../model/formulario.model';

export default {
  name: "TrfVisualizadorFormularios",
  components: {
    TrfGlobalLoader: defineAsyncComponent(() => import('../../../components/GlobalLoader/index.vue')),
    TrfEmpresaFormularioBase: defineAsyncComponent(() => import('../../Legalize/CadastroDeProcessos/Components/FormularioBaseEmpresa.vue')),
    TrfSocioFormularioBase: defineAsyncComponent(() => import('../../Legalize/CadastroDeProcessos/Components/FormularioBaseSocio.vue')),
    TrfVisualizarForm: defineAsyncComponent(() => import('../../../components/VisualizarForm/index.vue'))
  },
  async beforeRouteEnter(to, from, next) {
    const id = to.params.id;
    if (!!id) {
      next((vm) => vm.carregarDadosFormulario(id));
    } else {
      next((vm) => vm.$data.isDefaultForm = true);
    }
  },
  async beforeRouteUpdate(to) {
    const id = to.params.id;
    if (!!id) {
      this.carregarDadosFormulario(id);
    }
  },
  props: {
  },
  data() {
    return {
      formTemplate: null,
      isFormLoading: true,
      isDefaultForm: false 
    }
  },
  computed: {
    displayDefault() {
      return this.isDefaultForm || (this.formTemplate == null && !this.isFormLoading)
    },
    pageTitle() {
      const nomeFallBack = this.formTemplate.nome? this.formTemplate.nome : "Formulário - Legalização"
      const nome = this.formTemplate?.nomeHtml? this.formTemplate.nomeHtml : nomeFallBack;
      return nome
    },
    formData() {
      const formData = new Formulario();
      formData.asModel(this.formTemplate);
      return formData;
    }
  },
  methods: {
    async importTemplateFormularioService() {
      const { templateFormularioService } = await import('../../../service/template-formulario-service');
      return templateFormularioService
    },
    async carregarDadosFormulario(id) {
      this.isFormLoading = true;
      this.isDefaultForm = false;
      const idAsInt = parseInt(id);
      if (!Number.isFinite(idAsInt) || idAsInt <= 0) {
        this.isDefaultForm = true;
        this.isFormLoading = false;
        return
      }
      try {
        const templateFormularioService = await this.importTemplateFormularioService()
        const form = await templateFormularioService.adquirirPorId(id);
        this.formTemplate = form;
      } catch (e) {
        console.warn(e);
        routerUtils._carregarNovaRota("/formularios/")
      }
      this.isFormLoading = false;
    },
    doVoltar() {
      routerUtils._carregarNovaRota("/formularios/")
    },
    stopFocus() {
      document.activeElement.blur()
    }
  }
}
</script>

<style scoped>
  .box-visualizar {
    border-top:.75rem solid var(--primaryColor, #a82339);
    border-left:1rem solid #666666;
    border-radius:8px;
    padding:2em;
    width:100%;
    max-width:700px;
    box-sizing: border-box;
    box-shadow:2px 2px 2px #70757a66
  }
</style>